import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import ReactTooltip from 'react-tooltip'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { updateProjectBuildings } from '../../actions'
import { useMutation } from '@apollo/react-hooks'
import { MUTATE_PROJECT } from '../../queries/project'
import { styled } from '@mui/material/styles'
import '../../index.css'

const PREFIX = 'AddBuildingObstacles-dialog'
const classes = {
  main: `${PREFIX}`,
}

const DialogStyled = styled(Dialog)({
  [`&.${classes.main} .MuiTypography-h6`]: {
    textAlign: 'center',
  },
})

export default function AddObstacle() {
  const [name, setName] = React.useState('')
  const [open, setOpen] = React.useState(false)
  const dispatch = useDispatch()
  const { projects, selectedProjectId, remoteStorage } = useSelector(
    state => state
  )

  const [mutateProject] = useMutation(MUTATE_PROJECT)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    //props.onChange(false)
    //setName('')
  }

  const handleOk = () => {
    //props.onChange(false, name)
    setName('')
  }

  const handleChange = e => {
    setName(e.target.value)
  }

  const onDrop = useCallback(acceptedFiles => {
    acceptedFiles.forEach(() => {
      // eslint-disable-next-line no-undef
      const reader = new FileReader()

      reader.onabort = () => console.log('file reading was aborted')
      reader.onerror = () => console.log('file reading has failed')
      reader.onload = async function (e) {
        var obj = e.target.result
        var intern = JSON.parse(obj)
        // console.log('Parsed JSON data: ', intern)
        const geojson = JSON.stringify(intern)
        if (remoteStorage.projects) {
          let project = projects.filter(p => p.id === selectedProjectId)
          let mutateProjectInput = { ...project[0], geojson: geojson }
          delete mutateProjectInput.__typename
          await mutateProject({
            variables: { input: mutateProjectInput },
          })
        }

        dispatch(
          updateProjectBuildings({
            id: selectedProjectId,
            geojson: geojson,
          })
        )

        handleClose()
      }
      // read file contents
      acceptedFiles.forEach(file => reader.readAsBinaryString(file))
    })
  }, [])

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: '.geojson',
  })

  const files = acceptedFiles.map(f => (
    <li key={f.path}>
      {f.path} - {f.size} bytes
    </li>
  ))

  return (
    <div>
      <Button
        className="add-icon"
        data-tip
        data-for="registerTip"
        style={{}}
        onClick={handleClickOpen}
      >
        <ReactTooltip id="registerTip" place="right" effect="solid">
          Click to add downloaded obstacle
        </ReactTooltip>
        <AddCircleIcon style={{ color: 'black' }} />
      </Button>
      <DialogStyled
        disableEscapeKeyDown
        open={open}
        onClose={handleClose}
        className={classes.main}
      >
        <DialogTitle id="form-dialog-title">Add Building Obstacles</DialogTitle>
        <DialogContent>
          <section>
            <p>
              Obstacles can be downloaded from OpenStreetMap. Click{' '}
              <a
                href="https://overpass-turbo.eu/"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>{' '}
              and search for your location. Zoom to the right zoom level and
              click on 'Run' to select all the buildings in the area. Then click
              on 'Export' to download the obstacle as GeoJSON.
            </p>
          </section>
          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })}>
              <img
                style={{ width: '40px', height: '40px' }}
                src="http://www.file-extension.info/images/resource/formats/geojson.png"
                alt=""
              />
              <input style={{ textAlign: 'center' }} {...getInputProps()} />
              <p>Drag and drop, or click to select your downloaded file</p>
              <em>(Only *.geojson files will be accepted)</em>
            </div>
            <aside>
              <h4>Added files</h4>
              <ul>{files}</ul>
            </aside>
          </section>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk} color="primary">
            ADD
          </Button>
          <Button onClick={handleClose} color="primary">
            CANCEL
          </Button>
        </DialogActions>
      </DialogStyled>
    </div>
  )
}
